
<style scoped>
.btn-danger {
  border-color: #ff5855;
  background-color: #ff5855;
}

.resend {
  border-color: #ff5855;
  background-color: #fff;
  color: #ff5855;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>
    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Validación de mail</b-card-header>
      <b-card-body>
        <div class="row justify-content-center email-validation-form" v-if="cargado">
          <div class="col-lg-5 col-md-7">
            <div class="card bg-secondary shadow border-0" style="border-radius:10px;">
              <div
                class="card-body px-lg-5 py-lg-5 shadow"
                style="border:2px solid #d0d0d0;border-radius:10px;"
              >
                <div class="text-center">
                  <div class="row">
                    <div class="col-md-12">
                      <img
                        src="@/assets/verifymail.png"
                        class="img-fluid mb-2"
                        style="max-width:160px;"
                      />
                    </div>
                  </div>
                  <h3 class>Necesitamos validar tu e-mail</h3>
                  <div v-show="!showPinValidation">
                    <div class="row">
                      <div class="col-md-12 text-center">
                        <span>Por tu seguridad, ingresá tu nueva dirección de e-mail, presioná el botón "Enviar Correo" y seguí las instrucciones que se envian en el correo que te enviaremos.</span>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-12">
                        <base-input
                          addon-left-icon="ni ni-email-83"
                          placeholder="Email"
                          class="input-group-alternative mb-3"
                          v-model="email"
                        ></base-input>
                      </div>
                    </div>
                    <div class="row">
                      <div class="text-center col-md-12">
                        <button @click="pinValidate" class="btn btn-danger btn-lg">Enviar correo</button>
                      </div>
                    </div>
                  </div>
                  <div v-show="showPinValidation">
                    <b-card-text class="margin-top text-center" style="color:#9c9c9c;">
                      <label>Te enviamos un número de 6 dígitos</label>
                    </b-card-text>

                    <div class="row form-group justify-content-center">
                      <div class="col-md-12">
                        <label class="col-md-12 text-center">Código de verificación</label>
                        <div class="col-md-12 text-center" style="padding-left:0px">
                          <pincode-input
                            v-model="code"
                            ref="pincode-input"
                            secure
                            autocomplete="off"
                            :length="this.length"
                          />
                        </div>
                      </div>
                      <div class="col-md-12 text-center" style="padding-top:20px">
                        <base-button type="danger" size="md" @click="validateCode">Validar</base-button>
                      </div>
                      <div class="col-md-12 text-center" style="padding-top:20px">
                        <base-button
                          :disabled="buttonResend.buttonDisabled"
                          size="md"
                          class="resend"
                          @click="SendValidationCode"
                        >
                          <span>{{buttonResend.buttonText}}</span>
                        </base-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <!-- <pin-validation
      ref="pin-validation"
      :showModal.sync="showModalPinValidation"
      v-on:validPin="onValidPin"
      v-on:loadUsePaymentPin="onLoadUsePaymentPin"
    ></pin-validation> -->
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import PincodeInput from "vue-pincode-input";
import PinValidation from "@/views/Pin/PinValidation";

export default {
  name: "EmailValidation",
  components: {
    "pincode-input": PincodeInput,
    "pin-validation": PinValidation
  },
  props: {
    url: {
      type: String,
      default: "/dashboard",
      description: "Url para realizar push luego de validar"
    }
  },
  data() {
    return {
      code: "",
      length: 6,
      email: "",
      cargado: false,
      buttonResend: {
        buttonText: "Reenviar Código",
        buttonDisabled: false
      },
      paramCountDown: 0,
      countDown: 0,
      usePaymentPin: false,
      showPinValidation: false,
      // showModalPinValidation: false
    };
  },
  methods: {
    validateCode: function() {
      let context = this;
      var param = {
        Code: context.code,
        Email: context.email
      };
      axiosHelpers.axiosPost(
        "DoubleFactorSecurity/ValidateEmailMethod",
        param,
        this,
        function(data) {
          if (data.ResponseVM.Result) {
            notificationHelpers.showSuccess(
              "Validación de Email",
              "Se ha validado el Email correctamente",
              context
            );
            // context.$store.dispatch("EmailVerify", data.ResponseVM.Result);
            context.$router.push(context.url);
          } else {
            context.code = "";
          }
        }
      );
    },
    countDownTimer() {
      let context = this;
      if (context.paramCountDown > 0) {
        setTimeout(() => {
          context.paramCountDown -= 1;
          if (context.paramCountDown == 1)
            context.buttonResend.buttonText =
              "Disponible en " + context.paramCountDown.toString() + " segundo";
          else
            context.buttonResend.buttonText =
              "Disponible en " +
              context.paramCountDown.toString() +
              " segundos";
          this.countDownTimer();
        }, 1000);
      } else {
        context.buttonResend.buttonText = "Reenviar Código";
        context.buttonResend.buttonDisabled = false;
      }
    },
    SendValidationCode() {
      let context = this;
      let params = {
        SelectedMethodID: context.$store.getters.MailCodeMethodID,
        Aux: context.email
      };
      axiosHelpers.axiosPost(
        "DoubleFactorSecurity/GenerateSecurityCodeAndSendForDataModification",
        params,
        this,
        function(data) {
          if (data.ResponseVM.Result) {
            context.showPinValidation = true;
            context.paramCountDown = data.ResponseVM.TimeToResend;
            context.buttonResend.buttonDisabled = true;
            context.countDownTimer();
          } else {
            notificationHelpers.showError(
              "Validación",
              "No se ha podido validar su mail. Intente nuevamente",
              this
            );
          }
        }
      );
    },
    onValidPin(val) {
      let context = this;
      if (val) {
        context.SendValidationCode();
      }
    },
    onLoadUsePaymentPin(val) {
      let context = this;
      context.usePaymentPin = val;
    },
    pinValidate() {
      let context = this;
      // if (context.usePaymentPin) {
      //   context.showModalPinValidation = true;
      // } else {
        context.SendValidationCode();
      // }
    }
  },
  beforeMount() {
    let context = this;

    axiosHelpers.axiosPost(
      "Account/GetAccountMailForValidation",
      {
        AccountID: context.$store.getters.accountID
      },
      this,
      function(data) {
        context.cargado = true;
        if (data.ResponseVM.Email != null && data.ResponseVM.Email != "") {
          context.email = data.ResponseVM.Email;
        }
      }
    );
  }
};
</script>
